module.exports = __webpack_public_path__ + "static/media/logo_horizontal.c0b37494.png";